<template>
  <l-map style="height: 350px" :crs="crs" :options="{zoomControl: false}">
    <l-image-overlay :url="url" :bounds="bounds"></l-image-overlay>
    <l-marker
      @update:lat-lng="updatePosition"
      v-for="star in stars"
      :lat-lng="star"
      :key="star.name"
      :draggable="true"
    >
      <l-icon>
        <p style="color: #fff;">{{currentPosition}}</p>
        <v-icon>$mupi</v-icon>
      </l-icon>
      <l-popup :content="star.name" />
    </l-marker>
  </l-map>
</template>

<script>
import { LMap, LImageOverlay, LMarker, LPopup, LIcon } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LIcon
  },
  data() {
    return {
      url: "http://leafletjs.com/examples/crs-simple/uqm_map_full.png",
      bounds: [
        [-220.5, -490],
        [1021.5, 1023]
      ],
      crs: L.CRS.Simple,
      position: [0, 0],
      currentPosition: [175.2, 145.0],
      stars: [
        { name: "Sol", lng: 175.2, lat: 145.0 },
        { name: "Mizar", lng: 41.6, lat: 130.1 },
        { name: "Krueger-Z", lng: 13.4, lat: 56.5 },
        { name: "Deneb", lng: 218.7, lat: 8.3 }
      ]
    };
  },
  methods: {
    updatePosition(position) {
      this.currentPosition = position;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/others/Leaflet.vue